import { DispatchLockingSystemReducer } from ".."

export const setSystemName = (dispatch: DispatchLockingSystemReducer, systemName: string) => {
	dispatch({
		type: "SET_SYSTEM_NAME",
		payload: systemName,
	})
}
